import {
  createContext,
  ReactNode,
  useContext,
  useEffect,
  useState
} from 'react'
import translations from '@/translations'

type Language = 'en' | 'pt' | 'es'

type LanguageContextType = {
  language: Language
  setLanguage: (lang: Language) => void
}

const detectUserLanguage = (): Language => {
  const browserLanguage = navigator.language || navigator.languages?.[0] || 'en'

  const languageCode = browserLanguage.split('-')[0].toLowerCase()

  if (languageCode === 'pt') return 'pt'
  if (languageCode === 'es') return 'es'
  return 'en'
}

const LanguageContext = createContext<LanguageContextType | null>(null)

export function LanguageProvider({ children }: { children: ReactNode }) {
  const [language, setLanguage] = useState<Language>('en')

  const handleSetLanguage = (lang: Language) => {
    setLanguage(lang)
    translations.setLanguage(lang)
  }

  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect
    handleSetLanguage(detectUserLanguage())
  }, [])

  return (
    <LanguageContext.Provider
      value={{ language, setLanguage: handleSetLanguage }}
    >
      {children}
    </LanguageContext.Provider>
  )
}

export function useLanguage() {
  const context = useContext(LanguageContext)
  if (!context) {
    throw new Error('useLanguage must be used within LanguageProvider')
  }
  return context
}
